import { nanoid } from 'nanoid/async'
import { audioModal } from './audioModal'
import { updateNodeConnections } from '../../utils/functions'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { value: fileData } = await audioModal(oldData, node)

  if (fileData && Object.values(fileData).length >= 2) {
    // Create text unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }

    Object.assign(node.data, fileData)
    node.update()
    updateNodeConnections(node)
  }

  return false
}